import { Action, ActionReducer, createReducer, on } from '@ngrx/store';

import { LanguageActions } from './language.actions';
import { SUPPORTED_LANGUAGE } from './language.model';
import { LanguageState } from './language.state';

export const initLanguageState: LanguageState = {
  languageCode: undefined,
  loading: false,
  loaded: false,
};

export const languageReducer: ActionReducer<LanguageState, Action> = createReducer(
  initLanguageState,

  on(
    LanguageActions.getLanguage,
    (state, { languageCode }): LanguageState => ({
      ...state,
      languageCode,
      loading: true,
    })
  ),

  on(
    LanguageActions.getLanguageSuccess,
    (state, { languageCode }): LanguageState => ({
      ...state,
      languageCode,
      loading: false,
      loaded: true,
    })
  ),

  on(LanguageActions.getLanguageError, (state) => {
    const browserLanguage = navigator.language.split('-')[0];
    let languageCode = SUPPORTED_LANGUAGE[browserLanguage.toUpperCase()];

    // if the browser is set to a language that we do not support,
    // we should set English as the default language
    if (!languageCode) {
      languageCode = SUPPORTED_LANGUAGE.EN;
    }

    // we do not support dialects for Norwegian,
    // therefore for these dialects should return the main language code
    if (browserLanguage === 'nn' || browserLanguage === 'no') {
      languageCode = SUPPORTED_LANGUAGE.NB;
    }

    return {
      ...state,
      languageCode,
      loading: false,
      loaded: true,
    };
  }),

  on(
    LanguageActions.setLanguage,
    (state, { languageCode }): LanguageState => ({
      ...state,
      languageCode,
    })
  )
);
